import { render, staticRenderFns } from "./XmContact.vue?vue&type=template&id=ab70ab00&scoped=true"
import script from "./XmContact.vue?vue&type=script&lang=js"
export * from "./XmContact.vue?vue&type=script&lang=js"
import style0 from "./XmContact.vue?vue&type=style&index=0&id=ab70ab00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab70ab00",
  null
  
)

export default component.exports